import React from "react";

export default function Comment({ question, questions, setQuestions }) {
  const handleOnChange = () => {
    question.ignored = !question.ignored;
    question.value = null;
    question.comment = null;
    setQuestions([...questions]);
  };

  const isDirecionalRecommendQuestion = question?.Pergunta?.includes(
    "quanto você recomenda"
  );

  return (
    !isDirecionalRecommendQuestion && (
      <label style={{ marginBottom: 24, display: "block" }}>
        <input
          type="checkbox"
          checked={question.ignored}
          onChange={handleOnChange}
        />
        Não se aplica
      </label>
    )
  );
}
